export default __webpack_public_path__ + "static/media/landingpage.425d7049.jpg";